import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';
import { NAVIGATION_OFFSET_CSS_VARIABLE } from '@telialt/utils/src/NavigationUtils/constants';

export const BlockWrapper = styled.div<{ $isNegative?: boolean }>`
    scroll-margin-top: var(${NAVIGATION_OFFSET_CSS_VARIABLE});
    background-color: ${({ $isNegative }) => ($isNegative ? getPurpurColor('purple900') : getPurpurColor('gray50'))};
    padding: ${getPurpurSpacing('400')} 0 ${getPurpurSpacing('800')};

    ${purpurMedia('md')`
        padding: ${getPurpurSpacing('600')} 0 ${getPurpurSpacing('800')};
    `}
`;
